{
  "id": "inception-2010",
  "slug": "inception-2010",
  "title": "البداية",
  "title_fr": "Inception",
  "original_title": "Inception",
  "description": "لص يسرق أسرار الشركات من خلال تقنية مشاركة الأحلام، يُكلَّف بمهمة معكوسة: زرع فكرة في عقل رئيس تنفيذي.",
  "description_en": "A thief who steals corporate secrets through dream-sharing technology is given the inverse task of planting an idea into the mind of a CEO.",
  "description_fr": "Un voleur qui dérobe des secrets industriels grâce à une technologie de partage des rêves se voit confier la mission inverse : implanter une idée dans l'esprit d'un PDG.",
  "year": 2010,
  "release_date": "2010-07-16",
  "duration": "2h 28m",
  "duration_minutes": 148,
  "genres": [
    "Thriller",
    "Sci-Fi",
    "Action"
  ],
  "genres_ar": [
    "إثارة",
    "خيال علمي",
    "أكشن"
  ],
  "genres_fr": [
    "Thriller",
    "Science-fiction",
    "Action"
  ],
  "country": "US",
  "rating": 8.8,
  "cast": [
    "Leonardo DiCaprio",
    "Joseph Gordon-Levitt",
    "Elliot Page"
  ],
  "director": "Christopher Nolan",
  "poster": "https://image.tmdb.org/t/p/w500/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg",
  "backdrop": "https://image.tmdb.org/t/p/original/s3TBrRGB1iav7gFOCNx3H31MoES.jpg",
  "trailer_url": "https://www.youtube.com/watch?v=YoHD9XEInc0",
  "tags": [
    "dream",
    "heist",
    "nolan"
  ],
  "is_trending": true,
  "is_new": false,
  "video_source": {
    "type": "external",
    "source_id": "inception-2010-main",
    "protected": true
  },
  "watch_url": "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  "watch_token": "SB96Af8N9qmNUH5mj8Z-ZGSNweuPqbBkQ5N6ygKrlmLD3vL7-kGobLNc_DcFsJ6gxpeuyv48i5avhtCG3gWUonOAYO06LRvKc7kGguebKbW-klKPXW615YFV-F6lZqiMIEhyIEJQEXo8M6cJswDa8K_lmxQFQ9xzpdg3f4ISsT-z4feDeZK9VFTaWT5xeVb1Gsx2prZvsVi4rya--pxScnUPsmmYRSLoJYJONTGJmmOVCyFtethYFV7YVyrwtV7pSHGq-2bgpuSwGkCRjsgCxOQvptI3_gpgUL9-I0pw0zA4GTEWovlRcg6dc2yIzJ4PQxJG9hcQA05U8eBKthiC4rnryzLgxbrwhMknwMRr7j2KC3ZZTFThEQPoa5DG10IJDSH5F33VWfAW91omTZ2ch-qfgq0FJ3tnGo5EvfCjJHggaA",
  "article": [
    {
      "id": "h-1",
      "type": "heading",
      "level": 2,
      "text": "نظرة عامة على فيلم Inception"
    },
    {
      "id": "p-1",
      "type": "paragraph",
      "dropCap": true,
      "html": "يقدّم المخرج <b>كريستوفر نولان</b> في فيلم <i>Inception</i> رؤية بصرية وفكرية فريدة عن عالم الأحلام، حيث يمكن للص ماهر اقتحام العقل الباطن وسرقة الأفكار. لكن المهمة هذه المرّة معكوسة تماماً: زرع فكرة بدل سرقتها."
    },
    {
      "id": "p-2",
      "type": "paragraph",
      "html": "يقود <b>ليوناردو دي كابريو</b> فريقاً من المتخصصين في طبقات الحلم المتداخلة، ويعتمد السيناريو على بناء هرمي دقيق يجعل كل طبقة تستدعي قواعدها الخاصة في الزمن والجاذبية."
    },
    {
      "id": "h-2",
      "type": "heading",
      "level": 3,
      "text": "أبرز ما يميّز الفيلم"
    },
    {
      "id": "l-1",
      "type": "list",
      "ordered": false,
      "items": [
        "تصميم بصري مذهل للمشاهد المعكوسة وانهيار المدن داخل الأحلام.",
        "موسيقى <b>هانز زيمر</b> الأيقونية التي أصبحت علامة الفيلم.",
        "بنية سردية متعددة الطبقات تستحق أكثر من مشاهدة لفهم تفاصيلها.",
        "أداء قوي من <b>توم هاردي</b> و<b>جوزيف غوردون-ليفيت</b>."
      ]
    },
    {
      "id": "a-1",
      "type": "alert",
      "variant": "info",
      "title": "هل تعلم؟",
      "html": "استغرق نولان نحو <b>عشر سنوات</b> في تطوير سيناريو الفيلم قبل تصويره عام 2010، وفاز الفيلم بأربع جوائز أوسكار."
    },
    {
      "id": "q-1",
      "type": "quote",
      "html": "الفكرة كالفيروس... قويّة، مُعدية، يصعب اقتلاعها بمجرد أن تُزرَع.",
      "author": "Dom Cobb"
    },
    {
      "id": "h-3",
      "type": "heading",
      "level": 3,
      "text": "نصائح للمشاهدة"
    },
    {
      "id": "p-3",
      "type": "paragraph",
      "collapsible": true,
      "collapseTitle": "اقرأ شرح النهاية (يحتوي على حرق)",
      "html": "النهاية المفتوحة مع <b>السبّاحة الدوّارة</b> (Totem) تركها نولان عمداً غامضة. هناك مدرستان: الأولى ترى أن كوب عاد فعلاً إلى الواقع لأن السبّاحة بدأت تترنّح، والثانية ترى أنه ما زال في حلم لأن الكاميرا قطعت قبل توقّفها. الإجابة المقصودة هي أن <b>المهم لكوب نفسه ليس الواقع، بل لمّ شمله بأبنائه</b>."
    }
  ]
}